import DashboardForDepartmentActionTypes from './dashboardfordepartment.types';

interface DashboardForDepartmentState {
	dashboardfordepartmentData: any;
	attendanceBySectionwiseData: any;
	error: any;
	isLoading: boolean;
	data: any;
	attendanceData: any;
	attendanceLoading: boolean;
	attendanceError: any;
}

interface DashboardForDepartmentAction {
	type: string;
	payload: any;
}

const INITIAL_STATE: DashboardForDepartmentState = {
	dashboardfordepartmentData: null,
	attendanceBySectionwiseData: null,
	error: null,
	isLoading: false,
	data: null,
	attendanceData: null,
	attendanceLoading: false,
	attendanceError: null
};

const dashboardfordepartmentReducer = (state = INITIAL_STATE, action: DashboardForDepartmentAction): DashboardForDepartmentState => {
	switch (action.type) {
		case DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_START:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_SUCCESS:
			return {
				...state,
				isLoading: false,
				data: action.payload,
				error: null
			};
		case DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.payload
			};
		case DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_RESPONSE_CHANGED:
			return { ...state, dashboardfordepartmentData: action.payload };
		case DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_RESPONSE_REST_START:
			return { ...state, dashboardfordepartmentData: null };
		case DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_ATTENDANCE_BY_SECTIONWISE_START:
			return {
				...state,
				attendanceLoading: true,
				attendanceError: null
			};
		case DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_ATTENDANCE_BY_SECTIONWISE_SUCCESS:
			if (process.env.NODE_ENV === 'development') console.log('Reducer received success action:', {
				payload: action.payload,
				type: action.type,
				data: action.payload?.data?.data,
				currentState: state
			});

			const newState = {
				...state,
				attendanceLoading: false,
				attendanceData: action.payload,
				attendanceError: null,
				attendanceBySectionwiseData: action.payload?.data?.data?.[0] || null
			};

			if (process.env.NODE_ENV === 'development') console.log('New state after update:', newState);
			return newState;
		case DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_ATTENDANCE_BY_SECTIONWISE_FAILURE:
			return {
				...state,
				attendanceLoading: false,
				attendanceError: action.payload
			};
		case DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_ATTENDANCE_BY_SECTIONWISE_RESPONSE_CHANGED:
			return { ...state, attendanceBySectionwiseData: action.payload };
		case DashboardForDepartmentActionTypes.DASHBOARDFORDEPARTMENT_ATTENDANCE_BY_SECTIONWISE_RESPONSE_REST_START:
			return { ...state, attendanceBySectionwiseData: null };
		default:
			return state;
	}
};

export default dashboardfordepartmentReducer;
